

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// ADDMULTIPLEKYCS
// ADDMULTIPLEKYCS
const ADDMULTIPLEKYCS= createAsyncThunk(
  "addMultipleKYCs/addMultipleKYCs",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const addMultipleKYCsSlice = createSlice({
  name: "addMultipleKYCsSlice",
  initialState: {
    addMultipleKYCs: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfaddMultipleKYCs: (state) => {
        state.addMultipleKYCs.loading = false
        state.addMultipleKYCs.error = false
        state.addMultipleKYCs.data = []
        state.addMultipleKYCs.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(ADDMULTIPLEKYCS.fulfilled, (state, action) => {
      state.addMultipleKYCs = {
        ...state.addMultipleKYCs,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ADDMULTIPLEKYCS.pending, (state, action) => {
      state.addMultipleKYCs = {
        ...state.addMultipleKYCs,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ADDMULTIPLEKYCS.rejected, (state, action) => {
      state.addMultipleKYCs = {
        ...state.addMultipleKYCs,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const addMultipleKYCsAction = {
    ADDMULTIPLEKYCS,
};

export { addMultipleKYCsAction };
export default addMultipleKYCsSlice.reducer;
export const {setInitialStateOfaddMultipleKYCs} = addMultipleKYCsSlice.actions